import './_author-metadata.scss'
import React from 'react'
import {get} from 'lodash/fp'
import {renderIf} from '../../lib/util.js'

export default({authorJson, showAboutTheAuthor}) => {
  let headShot = get('image.fields.file.url', authorJson)
  authorJson = authorJson || {}
  return (
      <div className='author-metadata' itemProp="author" itemScope itemType="http://schema.org/Person">
        {renderIf(headShot, <img itemProp='image' className='author-image' src={headShot} alt={authorJson.name} />)}
        {/*renderIf(!headShot && showAboutTheAuthor, <h3 className='about-the-author'>About the Author</h3>)*/}
        {renderIf(!headShot, <h2 itemProp='name' style={headShot ? {} : {marginBottom: '1em', fontSize: '3em'}} className='author-name'> {authorJson.name} </h2>)}
        <div className='author-name-container'>
        {/*renderIf(headShot && showAboutTheAuthor, <h3 className='about-the-author'>About the Author</h3>)*/}
        {renderIf(headShot, <h2 itemProp='name' className='author-name'> {authorJson.name} </h2>)}
          <div 
            className='author-sharebtn-container' 
            style={{
              width: authorJson.twitter && authorJson.website ? '100px' : '50px',
              right: authorJson.twitter && authorJson.website ? '-125px' : '-75px',
            }}>
            {renderIf(authorJson.twitter, <a itemProp='url' className='author-twitter' href={`https://www.twitter.com/${authorJson.twitter}`} />)}
            {renderIf(authorJson.website, <a itemProp='url' className='author-website' href={authorJson.website} /> )}
            {renderIf(authorJson.linkedIn, <a itemProp='url' className='author-linkedin' href={authorJson.linkedIn} /> )}
          </div>
        </div>
        {renderIf(authorJson.biography, <p itemProp='description' className='author-biography'>{authorJson.biography}</p>)}
      </div>
  )
}
    //<div style={{paddingTop: '2em'}}>
      //<hr style={{borderTop: '2px solid #e7e9ee'}}/>
      //{renderIf(showAboutTheAuthor, <h3 className='about-the-author'>About the Author</h3>)}
    //</div>



// WEBPACK FOOTER //
// ./src/components/author-metadata/index.js